import React from 'react';
import { Table, Tag, Space } from 'antd';

import LevelChart from './levelChart';
import WidgetAjax from '../../../widget/WidgetAjax'

class FinancialPressure extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            chartValue: '极低'
        }

    }

    componentDidMount() {
        this.setState({ loading: false });
    }

    render() {
        const { chartValue } = this.state;

        const { title, id } = this.props;

        const levelDataSource = [
            {
                key: '1',
                name: '财务压力评分',
                age: 32,
            },
            {
                key: '2',
                name: '财务压力评分百分位数',
                age: 42,
            },
            {
                key: '3',
                name: '该评分下企业违法失信率',
                age: 42,
            },
            {
                key: '4',
                name: '全部企业平均违法失信率',
                age: 42,
            }
        ];

        const levelColumns = [
            {
                title: '指标名称',
                dataIndex: 'name',
                key: 'name',
                align:"left",
                width: '50%',
                className: 'tableTitle'
            },
            {
                title: '指标值',
                dataIndex: 'age',
                width: '50%',
                align:"left",
                key: 'age',
                className: 'tableTitle'
            },
        ];

        const normDataSource = [
            {
                key: '1',
                name: '资产负债率相对水平',
                age: '较低',
            },
            {
                key: '2',
                name: '交易顺差率相对水平',
                age: '较低',
            },
            {
                key: '3',
                name: '利润债务比相对水平',
                age: '较低',
            },
        ];

        const normColumns = [
            {
                title: '指标名称',
                dataIndex: 'name',
                key: 'name',
                align:"left",
                width: '50%',
                className: 'tableTitle'
            },
            {
                title: '指标值',
                dataIndex: 'age',
                key: 'age',
                align:"left",
                width: '50%',
                className: 'tableTitle'
            },
        ];

        const contrastDataSource = [
            {
                key: '1',
                name: '同地区（ 北京市）',
                age: '16',
                miaoshu:'财务能力与同地区企业相比',
                jieguo:'低'
            },
            {
                key: '2',
                name: '同行业（ 信息传输、软件和信息技术服务业）',
                age: '16',
                miaoshu:'财务能力与同行业企业相比',
                jieguo:'低'
            },
            {
                key: '3',
                name: '同经营时长（ 20Y+）',
                age: '16',
                miaoshu:'财务能力与同经营时长企业相比',
                jieguo:'低'
            },
            {
                key: '4',
                name: '同营收规模（ 1B+）',
                age: '16',
                miaoshu:'财务能力与同营收规模企业相比',
                jieguo:'低'
            },
        ];

        const contrastColumns = [
            {
                title: '比较范围',
                dataIndex: 'name',
                key: 'name',
                align:"left",
                width: '25%',
                className: 'tableTitle'
            },
            {
                title: '百分位',
                dataIndex: 'age',
                width: '25%',
                align:"left",
                key: 'age',
                className: 'tableTitle'
            },
            {
                title: '比较描述',
                dataIndex: 'miaoshu',
                width: '25%',
                align:"left",
                key: 'miaoshu',
                className: 'tableTitle'
            },
            {
                title: '强弱结果',
                dataIndex: 'jieguo',
                width: '25%',
                align:"left",
                key: 'jieguo',
                className: 'tableTitle'
            },
        ];



        return (
            <div className='common-box'>
                <div >
                    <div className='common-top' id={"PAYABLE_id"} >
                        <div className="img">
                            <img src={require("../../../img/riskCompass/bt_left.svg")} alt="es-lint want to get"></img>
                        </div>
                        <div className='common-survival' >{title}</div>
                    </div>
                    <div className='common-modular-all' style={{ paddingLeft: '21px' }}>
                        <div className='common-modular-all-modularTitle'>财务压力评分说明</div>
                        <div className='common-modular-all-brief'>
                            <p>财务压力评分：通过分析企业收付款时间序列、财务风险，对企业的偿债能力状况进行评估；评分越高，企业的财务压力越大。等级评分对应关系说明，资不抵债：1000，大：(800，1000），较大：(600，800]，一般：(500，600]，较小：(200，500]，小：(0，200]。</p>
                            <p>财务压力等级表示该等级下的企业各项历史经营财务指标具有相似的特征，不表示企业未来财务一定出现问题。</p>
                            <p>违法失信可能性是指根据全量企业数据评估的近3年严重违法失信企业的比例。</p>
                        </div>
                        <div className='common-modular-all-modularTitle'>财务压力等级和评分</div>
                        <div style={{ display: 'flex' }}>
                            <div style={{ width: '60%' }}>
                                <Table size="small" dataSource={levelDataSource} columns={levelColumns} pagination={false} />
                            </div>
                            <div style={{ width: '40%' }} className='common-modular-all-point-chart'>
                                <LevelChart title="成长潜力等级" id="financialPressure" value={chartValue}></LevelChart>
                            </div>
                        </div>
                        <div className='common-modular-all-modularTitle'>财务能力评估关键指标</div>
                        <Table size="small" dataSource={normDataSource} columns={normColumns} pagination={false} />
                        <div className='common-modular-all-modularTitle'>财务能力评分比较（百分位）</div>
                        <Table size="small" dataSource={contrastDataSource} columns={contrastColumns} pagination={false} />

                    </div>
                </div>
            </div>
        )
    }
}

export default FinancialPressure